var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.228 20.625.71-4.625H18.5v-3c0-1.266.619-2.5 2.606-2.5h2.019V6.562s-1.831-.312-3.581-.312c-3.657 0-6.044 2.216-6.044 6.225V16H9.437v4.625H13.5v11.181c.816.128 1.65.194 2.5.194.85 0 1.684-.066 2.5-.194V20.625h3.728Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Facebook_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  })))));
};
export default SvgFacebook;